module.exports = __webpack_public_path__ + "assets/img/TokenPocket.88df323b.png";